module.exports = __webpack_public_path__ + "static/img/yuda_logo.80e9e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yuda_logo.png
// module id = aatH
// module chunks = 29